import { Carousel } from "antd";
import React from "react";
import "./testimonials.css";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="integrations-header">
          <h2>Success Stories</h2>
          <p>
            Real results from teams who transformed challenges into achievements
            and scaled with confidence
          </p>
        </div>
        <Carousel
          autoplay
          arrows
          autoplaySpeed={3000}
          infinite
          easing={"linear"}
        >
          {props?.data ? (
            props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-12">
                <div className="testimonial">
                  <div className="testimonial-image">
                    {" "}
                    <img src={d.img} alt="" />{" "}
                  </div>
                  <div className="testimonial-content">
                    <p>"{d.text}"</p>
                    <div className="testimonial-meta"> - {d.name} </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div></div>
          )}
        </Carousel>
      </div>
    </div>
  );
};
